import React from 'react';
import { IconElements } from '../../config/icons';

const ErrorIcon = () => <IconElements.ErrorIcon className="w-12 h-12 mr-2" />;

export const DisplayError = () => (
    <div className="w-full h-full flex flex-col justify-center items-center p-8 rounded-lg text-bnd-red text-center ">
        <ErrorIcon />
        <p className="mt-4">Helaas, we kunnen nu even geen verbinding maken.</p>
    </div>
);

export const DisplaySmallError = () => (
    <div className="flex flex-col justify-center items-center p-8 text-bnd-red text-center ">
        <ErrorIcon />
    </div>
);
